import Colors from '@/constants/Colors';
import { Tag } from 'antd';
import ActivityTypeGlyph from '@/v2/domains/Activities/components/ActivityTypeGlyph/ActivityTypeGlyph';
import { StyledActivityIcon } from './ActivityTypeIcon.styled';

export default function ActivityTypeIcon({
  type,
  color = 'black',
  size = 18,
  withCircle,
  circleColor = Colors.lightGray,
  className = '',
  freeLabel = false,
  width = null,
  height = null,
}) {
  const icon = <ActivityTypeGlyph type={type} size={size} color={color} />;

  return withCircle ? (
    <StyledActivityIcon
      className={className}
      color={circleColor}
      style={{ width, height }}
    >
      {icon}
      {freeLabel ? (
        <Tag color={Colors.green} className="free-tag">
          FREE
        </Tag>
      ) : null}
    </StyledActivityIcon>
  ) : (
    icon
  );
}
